/**
 * 대표전화 — 번역하지 않는 사실값이라 언어 파일이 아니라 여기 한 곳에 둔다. 푸터·문의 구역·1:1 문의·개인정보 처리방침이
 * 모두 이 값을 읽어, 같은 사이트에서 서로 다른 연락처가 보이지 않는다. 영어 화면은 국제 표기, 그 밖의 언어는 국내 표기다.
 */
export const SITE_TEL = {
  domestic: "02-449-0120",
  international: "+82-2-449-0120",
} as const;

/** 화면 언어(`ko`·`en-US` 꼴)에 맞는 대표전화 표기 */
export function siteTelFor(language: string | undefined): string {
  return language?.split("-")[0] === "en"
    ? SITE_TEL.international
    : SITE_TEL.domestic;
}
